import {
  GOLD_550,
  MOON_200,
  MOON_500,
  MOON_650,
  RED_500,
  WHITE,
} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  margin: 24px 0 8px 0;
`;
Section.displayName = 'S.Section';

export const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  flex: 1 1 auto;
`;
SectionTitle.displayName = 'S.SectionTitle';

export const MetadataTitle = styled(SectionTitle)`
  margin: 24px 0 8px 0;
`;
MetadataTitle.displayName = 'S.MetadataTitle';

// TODO: These styles will be common with other pages, consider making a reusable component.
export const MetadataTable = styled.div`
  background-color: ${WHITE};
  width: 100%;
  border: 1px solid ${MOON_200};
  border-radius: 4px;
  padding: 12px;
`;
MetadataTable.displayName = 'S.MetadataTable';

export const Tr = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
`;
Tr.displayName = 'S.Tr';

export const Property = styled.div`
  color: ${MOON_650};
  font-weight: 600;
  white-space: nowrap;
  width: 200px;
`;
Property.displayName = 'S.Property';

export const ContentPanel = styled.div`
  flex: 1 1 auto;
`;
ContentPanel.displayName = 'S.ContentPanel';

export const ConfigUpdatePanel = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
ConfigUpdatePanel.displayName = 'S.ConfigUpdatePanel';

export const InvalidConfig = styled.div`
  color: ${RED_500};
  margin-left: 16px;
`;
InvalidConfig.displayName = 'S.InvalidConfig';

export const OnlyFutureNotice = styled.div`
  font-size: 14px;
  color: ${MOON_500};
  margin-left: 16px;
`;
OnlyFutureNotice.displayName = 'S.OnlyFutureNotice';

export const TemplateVariableFormWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > div {
    width: 400px;
  }
`;
TemplateVariableFormWrapper.displayName = 'S.TemplateVariableFormWrapper';

export const TemplateVariableHeaderText = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-right: 8px;
`;

TemplateVariableHeaderText.displayName = 'S.TemplateVariableHeaderText';

export const TemplateVariablesHeaderContainer = styled.div`
  display: flex;
  justify-content: left;
  margin-top: 16px;
`;

TemplateVariablesHeaderContainer.displayName = `S.TemplateVariablesHeaderContainer`;

export const ParseConfigButton = styled(Button)`
  height: 24px;
  width: 133px;
`;

export const WarningMessage = styled.div`
  font-size: 14px;
  color: ${GOLD_550};
`;
WarningMessage.displayName = 'S.WarningMessage';

// New styles for service configuration
export const ServiceConfigPanel = styled.div`
  background-color: ${WHITE};
  border: 1px solid ${MOON_200};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 16px;
`;
ServiceConfigPanel.displayName = 'S.ServiceConfigPanel';

export const ServiceTabs = styled.div`
  display: flex;
  border-bottom: 1px solid ${MOON_200};
  background-color: #f9f9f9;
  border-radius: 4px 4px 0 0;
`;
ServiceTabs.displayName = 'S.ServiceTabs';

export const ServiceTab = styled.div<{active: boolean}>`
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 2px solid
    ${props => (props.active ? '#1f77b4' : 'transparent')};
  background-color: ${props => (props.active ? WHITE : 'transparent')};
  font-weight: ${props => (props.active ? '600' : '400')};
  color: ${props => (props.active ? '#000' : MOON_650)};
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  &:hover {
    background-color: ${props => (props.active ? WHITE : '#f0f0f0')};
  }
`;
ServiceTab.displayName = 'S.ServiceTab';

export const RemoveServiceButton = styled.button`
  background: none;
  border: none;
  color: ${MOON_500};
  cursor: pointer;
  font-size: 16px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:hover {
    background-color: ${RED_500};
    color: ${WHITE};
  }
`;
RemoveServiceButton.displayName = 'S.RemoveServiceButton';
